import { render, staticRenderFns } from "./EvaluateList.vue?vue&type=template&id=1cc18cca&scoped=true"
import script from "./EvaluateList.vue?vue&type=script&lang=js"
export * from "./EvaluateList.vue?vue&type=script&lang=js"
import style0 from "./EvaluateList.vue?vue&type=style&index=0&id=1cc18cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc18cca",
  null
  
)

export default component.exports